import { makeStyles } from '@material-ui/core'


const CardTheme = makeStyles((theme) => ({
    root: {
        boxSizing: 'border-box',
        borderRadius: '10px',
        boxShadow: ' -5px 8px 10px rgba(87, 120, 131, 0.2);',
      },
      boxContainer: props => ({
        display: 'flex',
        flexDirection: 'column',
        padding: '20px',
        borderTopLeftRadius: '5px',
        borderBottomLeftRadius: '5px',
        cursor: 'pointer'
      }),
      boxDados: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      },
      textoQuantidade: {
        fontSize: '20px',
        margin: 0,
        padding: 0,
        fontWeight: 'bold'
      },
      textoDescricao: props => ({
        marginTop: 0,
        padding: 0,
        fontSize: '14px',
        fontWeight: 'bold'
      }),
      button: {
        textTransform: 'none',
      }
}));

export default CardTheme;